import { useMemo } from 'react';

interface Props {
  address: string;
  className?: string;
}

export default function Address({ address, className }: Props) {
  const maskAddress = useMemo(() => {
    if (!address) return '--';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }, [address]);

  return <span className={className}>{maskAddress}</span>;
}
